import { Box, Text, Grid } from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { api } from "../../services/api";
import { CityContext } from '../../Context/CityContext';
import { useLocation } from 'react-router-dom';
import { FilterChip } from "../FilterChip";

const readyDrinkTypeOptions = ["Bebida Mista", "Lata Ready-to-drink"];
const brandOptions = [
  "Carimbó","Equilibrista","YB do Brasil","StoneLight","Xeque-mate","Fifty",
  "Jambruna","Gin Flower","Drink Pronto","20's","Xa de Cana","Hazel",
  "Like Wine","Poente","Hardz","Whitte Rabbit","Easy Booze","Xangolião","Vanfall",
];

const SectionLabel = ({ children }) => (
  <Text fontSize="11px" fontWeight="800" color="rgba(0,74,51,0.55)" letterSpacing="0.08em" textTransform="uppercase" mb="10px">
    {children}
  </Text>
);

export function OtherDrinksFilters(props) {
  const location = useLocation();
  const [readyDrinkTypes, setReadyDrinkTypes] = useState([]);
  const [brands, setBrands] = useState([]);
  const { cityParam } = useContext(CityContext);

  async function filterProducts(types, activeBrands) {
    let url = `/api/v1/products?city_id=${cityParam}`;
    if (activeBrands.length > 0) url += `&ready_brands=${activeBrands.join(',')}`;
    if (types.length > 0) url += `&other_drink_types=${types.join(',')}`;
    if (types.length === 0 && activeBrands.length === 0) {
      const filter = new URLSearchParams(location.search).get("filter");
      if (filter) url += `&filter=${filter}`;
    }
    const response = await api.get(url);
    props.setProducts(response.data.products);
  }

  function toggleType(type) {
    const updated = readyDrinkTypes.includes(type) ? readyDrinkTypes.filter(t => t !== type) : [...readyDrinkTypes, type];
    setReadyDrinkTypes(updated);
    filterProducts(updated, brands);
  }

  function toggleBrand(brand) {
    const updated = brands.includes(brand) ? brands.filter(b => b !== brand) : [...brands, brand];
    setBrands(updated);
    filterProducts(readyDrinkTypes, updated);
  }

  return (
    <>
      <SectionLabel>Tipos</SectionLabel>
      <Grid templateColumns="repeat(2,1fr)" gap="8px" mb="20px">
        {readyDrinkTypeOptions.map((t, i) => (
          <FilterChip key={i} label={t} isActive={readyDrinkTypes.includes(t)} onClick={() => toggleType(t)} />
        ))}
      </Grid>

      <Box h="1px" bg="rgba(0,74,51,0.08)" mb="20px" />

      <SectionLabel>Marcas</SectionLabel>
      <Grid templateColumns="repeat(2,1fr)" gap="8px">
        {brandOptions.map((b, i) => (
          <FilterChip key={i} label={b} isActive={brands.includes(b)} onClick={() => toggleBrand(b)} />
        ))}
      </Grid>
    </>
  );
}
